<template>
	<section id="top" class="home mb-5">
		<div class="container text-center" :class="{image:image}">
			<router-link to="/" aria-label="CoproPrivée" class="d-block">
				<pic :sources="['/img/logo.webp', '/img/logo.png']" alt="CoproPrivée - Logo" class="logo" />
			</router-link>
			<template v-if="image">
				<h2 class="text-white">Gérez votre copropriété en toute simplicité !</h2>
				<div class="text-white">Une alternative pour prendre soin de votre copropriété.</div>
				<pic :sources="['/img/app.webp', '/img/app.png']" alt="CoproPrivée - Logo" class="img-app" />

<!--        <div class="position-relative">-->
<!--          <img :src="'/img/app2.png'"-->
<!--               style="margin-left: 150px; width: calc(100% - 150px + 45px);margin-top:-5%; margin-bottom: -10%"-->
<!--               data-rellax-speed="1"-->
<!--               data-rellax-percentage="1"-->
<!--               class="img2 rellax">-->
<!--&lt;!&ndash;          margin-top: 5vh; margin-bottom: -20vh&ndash;&gt;-->
<!--&lt;!&ndash;          &ndash;&gt;-->
<!--          <img :src="'/img/app1.png'"-->
<!--               style="position: absolute; width: calc(25% - 15px); bottom:-10%; left:0px; margin: 0"-->
<!--               data-rellax-speed="2"-->
<!--               data-rellax-percentage="1"-->
<!--               class="img1 rellax">-->
<!--        </div>-->
<!--               data-rellax-percentage="0"-->

<!--             data-rellax-zindex="5"-->
<!--        <div class="rellax">-->
<!--          I’m that default chill speed of "-2"-->
<!--        </div>-->
<!--        <div class="rellax" data-rellax-speed="7">-->
<!--          I’m super fast!!-->
<!--        </div>-->
<!--        <div class="rellax" data-rellax-speed="-4">-->
<!--          I’m extra slow and smooth-->
<!--        </div>-->

			</template>
		</div>
		<forme fill="white" />
	</section>
</template>
<style lang="scss" scoped>
	@import '../../src/assets/less/variables.scss';

	.home{
		position: relative;
		padding: 0;
		.container{
			padding-top: 5vh;
			padding-bottom: 5vh;
			&.image{
				padding-top: 10vh;
				.img-app{
					margin-bottom: -20vh;
				}
			}
		}

		.logo{
			width: 400px;
			max-width: 80%;
			margin: auto;
			display: block;
		}
		.img-app{
			display: block;
			width: 90%;
			position: relative;
			margin: auto;
		}

		h2{
			margin-top: 2.5vh;
			margin-bottom: 0;
			@include smartphones(){
				font-size: 25px;
				line-height: 30px;
			}
		}
	}
</style>
<script>
  // import Rellax from "rellax";
	export default {
		name:'Top',
		props:{
			image:{default:true}
		},
    // mounted() {
    //   new Rellax('.rellax', {
    //     // wrapper:'.wrapper',
    //     round: true,
    //   });
    // },
    data:function(){
			return {
				produits:null,
			}
		},
	}
</script>
